<div class="adx-widget-view-wrapper">
    <div #voiceMailWidgetContainer class="adx-voicemail-widget">

        <!-- Header -->
        <div class="adx-widget-header">
            <div class="adx-header-left">
                <i class="fas fa-voicemail adx-header-icon" aria-hidden="true"></i>
                <div class="adx-header-text">
                    @if (selectedVoicemail() && !isLoading()) {
                        <h2 class="adx-widget-title">{{ selectedVoicemail()!.name }}</h2>
                        <p class="adx-widget-subtitle">{{ 'ASTIMAX.VMAILBOX.WIDGET.HEADER.TITLE' | translate }} ({{ selectedVoicemail()!.nr }})</p>
                    } @else {
                        <h2 class="adx-widget-title">{{ 'ASTIMAX.VMAILBOX.WIDGET.HEADER.TITLE' | translate }}</h2>
                    }
                </div>
            </div>
            <div class="adx-header-actions">
            </div>
        </div>

        <!-- Widget disabled -->
        @if (!widgetPermissions.widgetEnabled) {
            <div class="adx-empty-state">
                <i class="fas fa-lock adx-empty-icon" aria-hidden="true"></i>
                <p class="adx-empty-title">{{ 'ASTIMAX.VMAILBOX.WIDGET.ACCESS_DENIED.TITLE' | translate }}</p>
                <p class="adx-empty-subtitle">{{ 'ASTIMAX.VMAILBOX.WIDGET.ACCESS_DENIED.SUBTITLE' | translate }}</p>
            </div>
        }

        @if (widgetPermissions.widgetEnabled) {

            <!-- Not configured — user must open settings and select a mailbox -->
            @if (isNotConfigured()) {
                <div class="adx-empty-state">
                    <i class="fas fa-cog adx-empty-icon" aria-hidden="true"></i>
                    <p class="adx-empty-title">{{ 'ASTIMAX.VMAILBOX.WIDGET.SETTING.NOT_CONFIGURED_TITLE' | translate }}</p>
                    <p class="adx-empty-subtitle">{{ 'ASTIMAX.VMAILBOX.WIDGET.SETTING.NOT_CONFIGURED_SUBTITLE' | translate }}</p>
                </div>
            }

            @if (!isNotConfigured()) {

                <!-- Loading -->
                @if (isLoading()) {
                    <div class="adx-loading-state">
                        <mat-spinner diameter="32"></mat-spinner>
                        <span class="adx-loading-text">{{ 'ASTIMAX.VMAILBOX.WIDGET.LOADING' | translate }}</span>
                    </div>
                }

                @if (!isLoading()) {
                    <mat-tab-group
                            class="adx-voicemail-tabs"
                            [selectedIndex]="selectedTabIndex()"
                            (selectedIndexChange)="selectedTabIndex.set($event)">

                        <!-- ═══════════════════════════════════════════
                             Messages
                             ═══════════════════════════════════════════ -->
                        <mat-tab>

                            <ng-template mat-tab-label>
                              <span class="adx-tab-label">
                                {{ 'ASTIMAX.VMAILBOX.WIDGET.TABS.MESSAGES' | translate }}
                                @if (unreadCount() > 0) {
                                  <span class="adx-tab-badge">{{ unreadCount() }}</span>
                                }
                              </span>
                            </ng-template>

                            <div class="adx-tab-content">

                                @if (error()) {
                                    <p class="adx-tab-error-banner">
                                        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
                                        {{ error() }}
                                    </p>
                                }

                                @if (isLoadingMessages()) {
                                    <div class="adx-tab-loading">
                                        <mat-spinner diameter="24"></mat-spinner>
                                    </div>
                                }

                                @if (!isLoadingMessages() && messagesError()) {
                                    <p class="adx-tab-error-banner">
                                        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
                                        {{ messagesError() }}
                                    </p>
                                }

                                @if (!isLoadingMessages() && !messagesError() && messages().length === 0) {
                                    <div class="adx-empty-state">
                                        <div class="adx-empty-icon-wrapper">
                                            <i class="fas fa-inbox" aria-hidden="true"></i>
                                        </div>
                                        <p class="adx-empty-title">{{ 'ASTIMAX.VMAILBOX.WIDGET.MESSAGES.EMPTY_TITLE' | translate }}</p>
                                        <p class="adx-empty-subtitle">{{ 'ASTIMAX.VMAILBOX.WIDGET.MESSAGES.EMPTY_SUBTITLE' | translate }}</p>
                                    </div>
                                }

                                @if (!isLoadingMessages() && messages().length > 0) {
                                    <ul class="adx-message-list"
                                        [attr.aria-label]="'ASTIMAX.VMAILBOX.WIDGET.MESSAGES.LIST_ARIA' | translate">
                                        @for (message of messages(); track message.id) {
                                            <li
                                                    class="adx-message-item"
                                                    [class.adx-message-unread]="message.isnew"
                                                    [class.adx-message-playing]="playingMessageId() === message.id"
                                                    (click)="playingMessageId() === message.id ? stopMessage() : playMessage(message)">

                                                <!-- Avatar -->
                                                <div class="adx-avatar-circle">
                                                    @if (audioLoadingId() === message.id) {
                                                        <mat-spinner diameter="20" class="adx-avatar-spinner"></mat-spinner>
                                                    } @else if (playingMessageId() === message.id) {
                                                        <i class="fas fa-voicemail" aria-hidden="true"></i>
                                                    } @else {
                                                        <i class="fas fa-voicemail" aria-hidden="true"></i>
                                                    }
                                                </div>

                                                <!-- Info -->
                                                <div class="adx-message-info">
                                                <span class="adx-message-caller">
                                                    @if (message.isnew) {
                                                        <span class="adx-unread-dot"
                                                              role="img"
                                                              [attr.aria-label]="'ASTIMAX.VMAILBOX.WIDGET.MESSAGES.UNREAD_ARIA' | translate">
                                                        </span>
                                                    }
                                                    @let caller = vmailbox.parseCallerId(message.callerid);
                                                    @if (caller.name) {
                                                        <span class="adx-caller-name">{{ caller.name }}</span>
                                                        @if (caller.number) {
                                                            <span class="adx-caller-number"> &#10088;{{ caller.number }}&#10089;</span>
                                                        }
                                                    } @else if (caller.number) {
                                                        <span class="adx-caller-number">{{ caller.number }}</span>
                                                    } @else {
                                                        {{ 'ASTIMAX.VMAILBOX.WIDGET.MESSAGES.UNKNOWN_CALLER' | translate }}
                                                    }
                                                </span>
                                                    <span class="adx-message-meta">
                                                    {{ formatTimestamp(message.timestamp) }} • {{ formatDuration(message.duration) }}
                                                </span>
                                                    @if (message.vmtext) {
                                                        <span class="adx-message-stt">{{ message.vmtext }}</span>
                                                    }
                                                    @if (messageErrors().get(message.id)) {
                                                        <span class="adx-message-inline-error">
                                                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                                            {{ messageErrors().get(message.id) }}
                                                    </span>
                                                    }
                                                    @if (playingMessageId() === message.id && audioUrls().get(message.id)) {
                                                        <audio
                                                                class="adx-inline-player"
                                                                [src]="audioUrls().get(message.id)"
                                                                controls
                                                                autoplay
                                                                (ended)="stopMessage()"
                                                                (click)="$event.stopPropagation()">
                                                        </audio>
                                                    }
                                                </div>

                                                <!-- Action buttons -->
                                                <div class="adx-message-actions"
                                                     role="group"
                                                     [attr.aria-label]="('ASTIMAX.VMAILBOX.WIDGET.MESSAGES.ACTIONS_GROUP_ARIA' | translate).replace('{{caller}}', vmailbox.parseCallerId(message.callerid).name || vmailbox.parseCallerId(message.callerid).number || ('ASTIMAX.VMAILBOX.WIDGET.MESSAGES.UNKNOWN_CALLER' | translate))"
                                                     (click)="$event.stopPropagation()">
                                                    <button
                                                            mat-icon-button
                                                            [matTooltip]="'ASTIMAX.VMAILBOX.WIDGET.MESSAGES.ACTION_CALLBACK_TOOLTIP' | translate"
                                                            [attr.aria-label]="'ASTIMAX.VMAILBOX.WIDGET.MESSAGES.ACTION_CALLBACK_ARI' | translate"
                                                            (click)="callBack(message)">
                                                        <i class="fas fa-phone" aria-hidden="true"></i>
                                                    </button>
                                                    <button
                                                            mat-icon-button
                                                            [matTooltip]="'ASTIMAX.VMAILBOX.WIDGET.MESSAGES.ACTION_DOWNLOAD_TOOLTIP' | translate"
                                                            [attr.aria-label]="'ASTIMAX.VMAILBOX.WIDGET.MESSAGES.ACTION_DOWNLOAD_ARIA' | translate"
                                                            (click)="downloadMessage(message)">
                                                        <i class="fas fa-download" aria-hidden="true"></i>
                                                    </button>
                                                    <button
                                                            mat-icon-button
                                                            [matTooltip]="'ASTIMAX.VMAILBOX.WIDGET.MESSAGES.ACTION_DELETE_TOOLTIP' | translate"
                                                            [attr.aria-label]="'ASTIMAX.VMAILBOX.WIDGET.MESSAGES.ACTION_DELETE_ARIA' | translate"
                                                            (click)="deleteMessage(message)">
                                                        <i class="fas fa-trash" aria-hidden="true"></i>
                                                    </button>
                                                </div>

                                            </li>
                                        }
                                    </ul>
                                }

                            </div>
                        </mat-tab>

                        <!-- ═══════════════════════════════════════════
                             Announcements
                             ═══════════════════════════════════════════ -->
                        <mat-tab [label]="'ASTIMAX.VMAILBOX.WIDGET.TABS.ANNOUNCEMENTS' | translate">
                            <div class="adx-tab-content">

                                @if (error()) {
                                    <p class="adx-tab-error-banner">
                                        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
                                        {{ error() }}
                                    </p>
                                }

                                @for (type of announcementTypes; track type; let last = $last) {
                                    <div class="adx-greeting-section">

                                        <h4 class="adx-greeting-title">{{ announcementLabel(type) }}</h4>

                                        <!-- Status line -->
                                        @if (announcementInfo().get(type)?.exists) {
                                            <p class="adx-greeting-status adx-greeting-status--exists">
                                                <i class="fas fa-check-circle" aria-hidden="true"></i>
                                                {{ 'ASTIMAX.VMAILBOX.WIDGET.ANNOUNCEMENTS.STATUS_EXISTS' | translate }}
                                            </p>
                                        } @else {
                                            <p class="adx-greeting-status">
                                                {{ 'ASTIMAX.VMAILBOX.WIDGET.ANNOUNCEMENTS.STATUS_EMPTY' | translate }}
                                            </p>
                                        }

                                        <!-- Inline error for this announcement type -->
                                        @if (announcementErrors().get(type)) {
                                            <p class="adx-announcement-inline-error">
                                                <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                                {{ announcementErrors().get(type) }}
                                            </p>
                                        }

                                        <!-- Inline player (visible while playing) -->
                                        @if (playingAnnouncementType() === type && announcementAudioUrls().get(type)) {
                                            <audio
                                                    class="adx-inline-player"
                                                    [src]="announcementAudioUrls().get(type)"
                                                    controls
                                                    autoplay
                                                    (ended)="stopAnnouncement()">
                                            </audio>
                                        }

                                        <!-- Recorder UI (visible while recording this type) -->
                                        @if (recordingType() === type) {
                                            <div class="adx-recorder-active">
                                                <span class="adx-recorder-dot"></span>
                                                <span class="adx-recorder-timer">{{ recordingDuration() }}</span>
                                                <button mat-flat-button color="warn" (click)="stopRecording()">
                                                    <i class="fas fa-stop" aria-hidden="true"></i>
                                                    {{ 'ASTIMAX.VMAILBOX.WIDGET.ANNOUNCEMENTS.ACTION_RECORD_STOP' | translate }}
                                                </button>
                                            </div>
                                        }

                                        <!-- Recorder error -->
                                        @if (recorderError() && recordingType() === null) {
                                            <p class="adx-recorder-error">
                                                <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
                                                {{ recorderError() }}
                                            </p>
                                        }

                                        <div class="adx-greeting-actions">

                                            <!-- Play / stop (only when announcement exists) -->
                                            @if (announcementInfo().get(type)?.exists) {
                                                @if (announcementLoadingType() === type) {
                                                    <mat-spinner diameter="20" class="adx-action-spinner"></mat-spinner>
                                                } @else if (playingAnnouncementType() === type) {
                                                    <button mat-stroked-button (click)="stopAnnouncement()">
                                                        <i class="fas fa-stop" aria-hidden="true"></i>
                                                        {{ 'ASTIMAX.VMAILBOX.WIDGET.ANNOUNCEMENTS.ACTION_STOP' | translate }}
                                                    </button>
                                                } @else {
                                                    <button mat-stroked-button (click)="playAnnouncement(type)">
                                                        <i class="fas fa-play" aria-hidden="true"></i>
                                                        {{ 'ASTIMAX.VMAILBOX.WIDGET.ANNOUNCEMENTS.ACTION_PLAY' | translate }}
                                                    </button>
                                                }
                                            }

                                            <!-- Upload from file -->
                                            <button mat-stroked-button
                                                    [disabled]="uploadingType() === type || recordingType() === type"
                                                    (click)="fileInput.click()">
                                                @if (uploadingType() === type) {
                                                    <mat-spinner diameter="16" class="adx-button-spinner"></mat-spinner>
                                                } @else {
                                                    <i class="fas fa-upload" aria-hidden="true"></i>
                                                }
                                                {{ 'ASTIMAX.VMAILBOX.WIDGET.ANNOUNCEMENTS.ACTION_UPLOAD' | translate }}
                                            </button>
                                            <input
                                                #fileInput
                                                type="file"
                                                accept="audio/wav,audio/*"
                                                style="display:none"
                                                (change)="uploadAnnouncement(type, $event)">

                                            <!-- Record from microphone -->
                                            @if (recordingType() === null || recordingType() === type) {
                                                @if (recordingType() !== type) {
                                                    <button mat-stroked-button
                                                            [disabled]="uploadingType() === type || requestingMic()"
                                                            (click)="startRecording(type)">
                                                        @if (requestingMic()) {
                                                            <mat-spinner diameter="16" class="adx-button-spinner"></mat-spinner>
                                                        } @else {
                                                            <i class="fas fa-microphone" aria-hidden="true"></i>
                                                        }
                                                        {{ 'ASTIMAX.VMAILBOX.WIDGET.ANNOUNCEMENTS.ACTION_RECORD' | translate }}
                                                    </button>
                                                }
                                            }

                                            <!-- Download (only when announcement exists) -->
                                            @if (announcementInfo().get(type)?.exists) {
                                                <button mat-stroked-button (click)="downloadAnnouncement(type)">
                                                    <i class="fas fa-download" aria-hidden="true"></i>
                                                    {{ 'ASTIMAX.VMAILBOX.WIDGET.ANNOUNCEMENTS.ACTION_DOWNLOAD' | translate }}
                                                </button>
                                            }

                                            <!-- Delete -->
                                            <button
                                                    mat-stroked-button
                                                    color="warn"
                                                    [disabled]="!announcementInfo().get(type)?.exists || uploadingType() === type"
                                                    (click)="deleteAnnouncement(type)">
                                                <i class="fas fa-trash" aria-hidden="true"></i>
                                                {{ 'ASTIMAX.VMAILBOX.WIDGET.ANNOUNCEMENTS.ACTION_DELETE' | translate }}
                                            </button>

                                        </div>
                                    </div>

                                    @if (!last) {
                                        <mat-divider></mat-divider>
                                    }
                                }

                            </div>
                        </mat-tab>

                    </mat-tab-group>
                }

            } <!-- /!isNotConfigured -->

        }

    </div>
</div>
